import {
  FETCH_TICKET_START,
  FETCH_TICKET_SUCCESS,
  FETCH_TICKET_FAILURE,
  FETCH_HOLD_TICKETS_SUCCESS,
  SET_HOLD_TICKET_INDEX,
  UPDATE_TICKET_START,
  UPDATE_TICKET_SUCCESS,
  UPDATE_TICKET_FAILURE,
  SELLER_RESPONSIVE_SNACKBAR,
  SELLER_RESPONSIVE_CLEAR_SNACKBAR,
} from "../constants/sellerResponsive.constants";

const defaultState = {
  ticket: null,
  holdTickets: [],
  holdTicketIndex: -1,
  loading: false,
  error: null,
  snackbar: null,
};

export default function sellerResponsive(state = {}, action) {
  const currentState = state.sellerResponsive || defaultState;

  switch (action.type) {
    case FETCH_TICKET_START:
      return {
        ...state,
        sellerResponsive: {
          ...currentState,
          loading: true,
          error: null,
        },
      };
    case FETCH_TICKET_SUCCESS:
      return {
        ...state,
        sellerResponsive: {
          ...currentState,
          loading: false,
          ticket: action.payload?.data || {},
          holdTickets: [],
          holdTicketIndex: -1,
        },
      };
    case FETCH_HOLD_TICKETS_SUCCESS: {
      const holdTickets = action.payload?.data || [];
      return {
        ...state,
        sellerResponsive: {
          ...currentState,
          loading: false,
          holdTickets,
          holdTicketIndex: holdTickets.length ? 0 : -1,
          ticket: holdTickets[0] || {},
        },
      };
    }
    case SET_HOLD_TICKET_INDEX: {
      const index = action.payload;
      return {
        ...state,
        sellerResponsive: {
          ...currentState,
          holdTicketIndex: index,
          ticket: currentState.holdTickets?.[index] || {},
        },
      };
    }
    case FETCH_TICKET_FAILURE:
      return {
        ...state,
        sellerResponsive: {
          ...currentState,
          loading: false,
          error: action.payload,
        },
      };
    case UPDATE_TICKET_START:
      return {
        ...state,
        sellerResponsive: {
          ...currentState,
          loading: true,
          error: null,
        },
      };
    case UPDATE_TICKET_SUCCESS: {
      const isHoldCarousel = (currentState.holdTickets || []).length > 0;
      if (isHoldCarousel) {
        const actedTicketId = currentState.ticket?.id;
        const remainingHoldTickets = currentState.holdTickets.filter(
          (ticket) => ticket.id !== actedTicketId
        );
        const holdTicketIndex = Math.min(
          currentState.holdTicketIndex,
          remainingHoldTickets.length - 1
        );
        return {
          ...state,
          sellerResponsive: {
            ...currentState,
            loading: false,
            holdTickets: remainingHoldTickets,
            holdTicketIndex,
            ticket:
              holdTicketIndex >= 0 ? remainingHoldTickets[holdTicketIndex] : null,
          },
        };
      }
      return {
        ...state,
        sellerResponsive: {
          ...currentState,
          loading: false,
          ticket: null,
        },
      };
    }
    case UPDATE_TICKET_FAILURE:
      return {
        ...state,
        sellerResponsive: {
          ...currentState,
          loading: false,
          error: action.payload,
        },
      };
    case SELLER_RESPONSIVE_SNACKBAR:
      return {
        ...state,
        sellerResponsive: {
          ...currentState,
          snackbar: {
            message: action.payload.message,
            severity: action.payload.severity,
          },
        },
      };
    case SELLER_RESPONSIVE_CLEAR_SNACKBAR:
      return {
        ...state,
        sellerResponsive: {
          ...currentState,
          snackbar: null,
        },
      };
  }
}
